module.exports = __webpack_public_path__ + "static/media/modx.64c46ac8.svg";